export default class InvalidBooleanEnvironmentVariable extends Error {
  constructor(name: string, value: string | undefined) {
    super(`Environment variable "${name}" is not a valid boolean: ${value}`)

    this.name = 'InvalidBooleanEnvironmentVariable'
  }
}
